import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const timeAgo = (value) => {
  if (!value) return "";
  const date = dayjs(value);
  if (!date.isValid()) return String(value);
  return date.fromNow();
};
